import { Component } from "@angular/core";
import { VideoLightboxService } from "../../services/video-lightbox.service";

@Component({
  selector: "common-marketing-hero",
  templateUrl: "./marketing-hero.component.html",
  styleUrls: ["./marketing-hero.component.scss"],
})
export class MarketingHeroComponent {
  constructor(private videoLightboxService: VideoLightboxService) {}

  watchVideo() {
    this.videoLightboxService.create("https://www.youtube.com/embed/D3G4XivvKCQ?autoplay=1&rel=0");
  }
}
